




















































import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapGetters, mapActions } from 'vuex';
import { Popup } from '@/shared/models/view/popup-viewmodel';
import { Config } from '../models/config-viewmodel';
import MessageComponent from '@/shared/components/Message.vue';
import { Study } from '../models/grade-viewmodels';
import StudentService from '@/shared/services/student-service';
import HttpService from '@/shared/services/http-service';

@Component({
    name: 'ExportCertifiedDialog',
    computed: {
        ...mapState(['config']),
        ...mapState('root', ['popupComponent']),
        ...mapGetters('root', ['label']),
        ...mapGetters(['noExcurStudy', 'excurStudy', 'message', 'studyListTranscriptRequestable'])
    },
    components: {
        MessageComponent
    },
    methods: {
        ...mapActions("root", ["closePopup"])
    }
})
export default class ExportCertifiedDialog extends Vue {
    public popupComponent!: Popup;
    public selectedLanguage: string = 'nl';

    public selectedStudy!: Study;
    public config!: Config;
    public form!: any;

    private labelModule = 'ModuleOverview';
    private errorMessage: string = '';

    private checkValidInput(): boolean {
        if (!this.selectedStudy) return false;
        return true;
    }

    private sendCertifiedGradesRequest(): void {
        let vuNetId = this.config.vuNetIdStudent;
        this.errorMessage = '';

        StudentService.postRequestCertifiedGrades(vuNetId, this.selectedStudy.id, this.selectedLanguage, this.form, HttpService).then(result => {
            this.$store.commit('setSubmit', true);
            this.$store.commit('setLoading', false);
            this.$store.commit('removeFormErrors', name);

            this.$store.commit('setTranscriptRequest', result);
            this.$store.commit('root/setPopupComponent', {name: 'ExportConfirmationDialog'});
        }).catch(error => {
            if (error.response.data.errors) {
                this.processServerErrors(error.response.data.errors);
            } else {
                console.log(error)
                this.errorMessage = (this.config.language === 'nl' ?
                    'Er gaat iets fout, probeer het later nog een keer. ' :
                    'Something went wrong, please try again later. ') + error;
                this.$store.commit('root/setErrors', [
                    this.errorMessage
                ]);
            }
            this.$store.commit('setLoading', false);
        });

    }

    private processServerErrors(errors: any) {
        Object.entries(errors).forEach((error: any) => {
            this.handleError(error[1].map((single: string) => {
                return { msg: single, key: '' }
            }), error[0])
        })
    }

    private handleError(errors: { msg: string, key: string }[], name: string) {
        this.$store.commit('removeFormErrors', name);

        errors.forEach(({ key, msg }) => {
            this.$store.commit('addFormErrors', { name, error: { key, msg } });
        })
    }

    private getSelectedStudy(id: string) {
        let studyList = this.$store.getters.studyListTranscriptRequestable;
        let selectedStudy = studyList.find((study: Study) => study.id === id);
        return selectedStudy ?? studyList[0];
    }

    private getSessionStudyId() {
        let sessionStudy = sessionStorage.getItem('setSelectedStudy') ?? "";
        return JSON.parse(sessionStudy);
    }

    created() {
        try {
            let hash = window.location.hash.replace('#/', '');
            let match = hash.match(/study=([^&]+)/);  //Find the value for study from the hash string
            let studyId = match ? match[1] : null;

            this.selectedStudy = this.getSelectedStudy(studyId ?? this.getSessionStudyId());
        } catch (err) {
            console.log('Error loading study choice by session storage')
        }
    }
}
